export const REQUEST_STATUSES = {
  DRAFT: "Draft",
  AWAITING_USER_ACTION: "Awaiting user action",
  AWAITING_SUPERVISOR_ACTION: "Awaiting supervisor action",
  AWAITING_ADDITIONAL_ACCEPTOR_ACTION: "Awaiting additional acceptor action",
  AWAITING_AP_ACCEPTANCE: "Awaiting AP acceptance",
  AWAITING_COST_GROUP_APPROVER: "Awaiting cost group approver",
  AWAITING_SAP_EXPORT: "Awaiting SAP export",
  AWAITING_SAP_IMPORT: "Awaiting SAP import",
  AWAITING_TRAVEL_ACCEPTOR_ACTION: "Awaiting travel acceptor action",
  PROCESSED: "Processed",
  CANCELED: "Canceled",
  ERROR: "Error",

  // Settlement
  AWAITING_USER_SETTLEMENT: "Awaiting user settlement",
  AWAITING_SUPERVISOR_SETTLEMENT_ACTION:
    "Awaiting supervisor settlement action",
  AWAITING_ADDITIONAL_ACCEPTOR_SETTLEMENT:
    "Awaiting settlement additional acceptor",
  AWAITING_AP_SETTLEMENT: "Awaiting AP settlement",
  AWAITING_COST_GROUP_SETTLEMENT: "Awaiting cost group settlement",
};
